exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".case-detail-title[data-v-3e85533b]{font-weight:bolder;font-size:20px;color:#2d8cf0;margin-bottom:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e85533b","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/caseDetail/CaseDetail.vue
// module id = TS13
// module chunks = 2